import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewSalesLeadComponent } from './new-sales-lead.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAutocompleteModule, DxHtmlEditorModule, DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule, DxToolbarModule, DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule } from 'devextreme-angular';

@NgModule({
  declarations: [NewSalesLeadComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextAreaModule,
    DxButtonModule,
    DxAutocompleteModule,
    DxHtmlEditorModule,
    DxToolbarModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxSelectBoxModule,
  ], 
  exports: [NewSalesLeadComponent]
})
export class NewSalesLeadModule { }
